
import {
  defineComponent,
  getCurrentInstance,
  PropType,
  ref,
  toRefs,
  watch,
  toRef,
} from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import { LookupAPI } from "@/services/api/Lookup.service";
import { useToast } from "vue-toastification";
import { createMicroServiceURL } from "@/helpers/microServiceMapper";
import VZModal from "@/components/content/VZModal.vue";

export default defineComponent({
  name: "vz-delete-modal",
  emits: ["close", "on-delete", "bulk-delete"],
  components: { VZModal },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    pageName: { type: String, default: "" },
    selectedForAction: {
      type: Array as PropType<string[]>,
      default: () => [],
      required: true,
    },
    deleteText: { type: String, default: "No data found" },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const toast = useToast();
    const message = t("common.deleteSuccessMessage");
    const showDialog = toRef(props, "showDialog");
    const { selectedForAction, viewName, pageName } = toRefs(props);
    const vnodeProps = getCurrentInstance()?.vnode.props || {};
    const deleteBtnLoading = ref<boolean>(false);
    const close = () => {
      var appElement = document.getElementById("app");
      if (appElement) {
        appElement.click();
      }
      emit("close");
    };
    watch(showDialog, (newValue) => {
      if (newValue) {
        deleteBtnLoading.value = false;
      }
    });
    const applyDelete = async () => {
      deleteBtnLoading.value = true;
      if ("onBulkDelete" in vnodeProps) {
        emit("bulk-delete", selectedForAction.value);
      } else {
        try {
          deleteBtnLoading.value = true;
          await LookupAPI.getInstance().bulkDeleteEntity(
            createMicroServiceURL(viewName.value),
            selectedForAction.value
          );
          emit("on-delete");
          emit("close");
          let deleteMsg = "Selected " + pageName.value + "(s)" + " " + message;
          toast.success(deleteMsg);
        } finally {
          deleteBtnLoading.value = false;
        }
      }
    };
    return {
      t,
      applyDelete,
      deleteBtnLoading,
      close,
    };
  },
});
